import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DeleteRegionResponse, RegionItem, RegionResponse } from '../../models/region';
import { CreateResponse } from '../../models/utils';

@Injectable({
  providedIn: 'root',
})
export class RegionsService {
  #http = inject(HttpClient);
  #apiUrl = environment.apiUrl;
  #authHeaders = new HttpHeaders({
    Authorization: '',
  });

  getApiUrl(): string {
    return this.#apiUrl;
  }

  fetchRegions(queryParams?: Partial<any>): Observable<RegionResponse> {
    let params = new HttpParams();

    if (queryParams) {
      Object.entries(queryParams).forEach(([key, value]) => {
        if (value) {
          params = params.set(key, value);
        }
      });
    }

    return this.#http.get<RegionResponse>(`${this.#apiUrl}/api/region/list`, {
      headers: this.#authHeaders,
      params,
    });
  }

  getAllRegions(): Observable<any> {
    let currentPage = 1;
    let allRegions: any[] = [];

    return new Observable<any[]>((observer) => {
      const fetchPage = () => {
        this.#http
          .get<any>(
            `${this.#apiUrl}/api/region/list?page=${currentPage}`,
            {
              headers: this.#authHeaders,
            }
          )
          .subscribe({
            next: (resp) => {
              allRegions = allRegions.concat(resp.data);
              if (resp.next_page_url) {
                currentPage++;
                fetchPage();
              } else {
                observer.next(allRegions);
                observer.complete();
              }
            },
            error: (error) => observer.error(error),
          });
      };

      fetchPage();
    });
  }

  addRegion(region: string): Observable<RegionItem> {
    const payload = {
      region: region,
    };
    return this.#http
      .post<CreateResponse<RegionItem>>(`${this.#apiUrl}/api/region`, payload, {
        headers: this.#authHeaders,
      })
      .pipe(map((resp) => resp.data));
  }

  updateRegion(id: number, region: string): Observable<RegionItem> {
    const payload = {
      region: region,
    };
    return this.#http
      .patch<CreateResponse<RegionItem>>(
        `${this.#apiUrl}/api/region/${id}`,
        payload,
        { headers: this.#authHeaders }
      )
      .pipe(map((resp) => resp.data));
  }

  deleteRegion(id: number): Observable<DeleteRegionResponse> {
    return this.#http.delete<DeleteRegionResponse>(
      `${this.#apiUrl}/api/region/${id}`,
      { headers: this.#authHeaders }
    );
  }
}
